import { render, staticRenderFns } from "./ExtraFieldNames.vue?vue&type=template&id=2c80eade"
import script from "./ExtraFieldNames.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldNames.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c80eade')) {
      api.createRecord('2c80eade', component.options)
    } else {
      api.reload('2c80eade', component.options)
    }
    module.hot.accept("./ExtraFieldNames.vue?vue&type=template&id=2c80eade", function () {
      api.rerender('2c80eade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/ExtraFieldNames.vue"
export default component.exports